import React from 'react';
import ReactTooltip from 'react-tooltip';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  status: 'available'|'sold'|'pending',
  id: number,
  listings_type: string,
}

const StatusBadge: React.FC<Props> = ({
  status,
  id,
  listings_type,
}) => {
  let textColor = getComputedCSSVariable('black');
  let backgroundColor = getComputedCSSVariable('admin-button-gray');
  let borderColor = 'border-black';

  switch (status) {
    case 'sold':
      textColor = getComputedCSSVariable('check-green');
      backgroundColor = getComputedCSSVariable('light-green');
      borderColor = 'border-check-green';
      break;
    case 'pending':
      textColor = getComputedCSSVariable('pending-orange');
      backgroundColor = getComputedCSSVariable('orange-100');
      borderColor = 'border-pending-orange';
      break;
    default:
      break;
  }
  return (
    <>
      <a
        className="b-none d-block m-auto text-center dot-wrapper"
        style={{
          borderRadius: '25px',
          backgroundColor,
        }}
        data-place="top"
        data-for={`${status}-${listings_type}-${id}`}
        data-tip
      >
        <span
          className="dot"
          aria-hidden={true}
          style={{
            backgroundColor: textColor,
          }}
        />
      </a>
      <ReactTooltip
        id={`${status}-${listings_type}-${id}`}
        aria-haspopup={true}
        place="right"
        delayHide={500}
        effect="solid"
        type="success"
        backgroundColor={backgroundColor}
        border={true}
        borderColor={textColor}
        className={`hover-tool-tip-profiles ${borderColor}`}
      >
        <p
          className="m-0"
          style={{
            color: textColor,
          }}
        >
          {status === 'available' ? 'Unsold' : status}
        </p>
      </ReactTooltip>
    </>
  );
};

export default StatusBadge;
